import { HttpResponse } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterModule } from '@angular/router';
import { geracaozResolver, modalitiesResolver } from '@frontend/frontend.route';
import { CandidatureService } from '@geracaoz/candidature/candidature.service';
import { CandidatureFrontendGeracaoz, ICandidatureFrontendGeracaoz } from '@model/geracaoz/candidature-frontend.model';
import { AbstractFrontendComponent } from 'app/frontend/abstract-frontend.component';
import { GeracaozActionsComponent } from 'app/frontend/geracaoz/geracaoz-actions.component';
import { GeracaozCandidatureFrontendComponent } from 'app/frontend/geracaoz/geracaoz-candidature-frontend.component';
import { GeracaozCandidatureInscriptionComponent } from 'app/frontend/geracaoz/geracaoz-candidature-inscription.component';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GeracaozSlugResolve implements Resolve<ICandidatureFrontendGeracaoz> {
  constructor(private service: CandidatureService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<ICandidatureFrontendGeracaoz> | Observable<never> {
    const slug = route.params['slug'];
    if (slug) {
      return this.service.findBySlug(slug).pipe(
        mergeMap((candidature: HttpResponse<ICandidatureFrontendGeracaoz>) => {
          if (candidature.body) {
            return of(candidature.body);
          } else {
            void this.router.navigate(['404']).then();
            return EMPTY;
          }
        })
      );
    }
    return of(new CandidatureFrontendGeracaoz());
  }
}

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: AbstractFrontendComponent,
        data: {
          authorities: [],
          pageTitle: 'home.geracaoz.title',
          breadcrumb: { alias: 'geracaoz' },
        },
        resolve: {
          programEnum: geracaozResolver,
          modalities: modalitiesResolver,
        },
      },
      {
        path: 'acoes',
        component: GeracaozActionsComponent,
        data: {
          authorities: [],
          pageTitle: 'home.geracaoz.title',
          breadcrumb: { alias: 'geracaoz' },
        },
        resolve: {
          programEnum: geracaozResolver,
        },
      },
      {
        path: 'acoes/:slug',
        component: GeracaozCandidatureFrontendComponent,
        data: {
          authorities: [],
          pageTitle: 'home.geracaoz.title',
          breadcrumb: { alias: 'geracaoz' },
        },
        resolve: {
          programEnum: geracaozResolver,
          candidature: GeracaozSlugResolve,
        },
      },
      {
        path: 'inscricao',
        component: GeracaozCandidatureInscriptionComponent,
        data: {
          authorities: [],
          pageTitle: 'home.geracaoz.title',
          breadcrumb: { alias: 'geracaoz' },
        },
        resolve: {
          programEnum: geracaozResolver,
        },
      },
    ]),
  ],
})
export class GeracaozFrontendModule {}
